import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const CustomerRestaurantOrderDetailSlice = createSlice({
    name: "customerRestaurantOrderDetail",
    initialState,
    reducers: {
        getCustomerRestaurantOrderDetailRequest(state) {
            state.loading = true;
        },
        getCustomerRestaurantOrderDetailRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getCustomerRestaurantOrderDetailRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getCustomerRestaurantOrderDetailRequest,
    getCustomerRestaurantOrderDetailRequestSuccess,
    getCustomerRestaurantOrderDetailRequestError,
} = CustomerRestaurantOrderDetailSlice.actions;

export default CustomerRestaurantOrderDetailSlice.reducer;
